import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import TodoListPage from '../components/TodoListPage'
import {
  actionCreators,
  ITodoListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectShowCompleted,
  selectTotalItems,
} from '../modules/todoList'

export default connect(
  createStructuredSelector<ApplicationState, ITodoListState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    showCompleted: selectShowCompleted(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(TodoListPage)
